import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'


import axios from "axios";
import { Dialog, Transition } from "@headlessui/react";
import { FaWhatsapp } from "react-icons/fa";
import {
  XMarkIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/20/solid";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

import { Pagination } from "../../helper/HelperTwo";
import ChitDetailsCreate from './ChitDetailsCreate';
import ChitDetailsEdit from './ChitDetailsEdit';
import Loader from '../../../utils/Loader';
import ChitDetailsAddPayment from './ChitDetailsAddPayment';


const ChitDetailsList = () => {
  const [chitDetailCreateOpen, setChitDetailsCreateOpen] = useState(false)
  const [chitDetailsEditOpen, setChitDetailsEditOpen] = useState(false)
  const [chitDetailsAddPayment, setChitDetailsAddPayment] = useState(false)
  const [customerEditOpen, setCustomerEditOpen] = useState(false);
  const [customerViewOpen, setCustomerViewOpen] = useState(false);
  const [formData, setFormData] = useState([])
  const [pagination, setPagenation] = useState(null)
  const [pagenationLink, setPagenationLink] = useState([])
  const [paginationData, setPaginationData] = useState(null)
  const [customerId, setCustomerId] = useState({})
  const [customerDelete, setCustomerDelete] = useState(false)
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);

  const [deleteMsg, setDeleteMsg] = useState(
    "Are you sure you want to delete the Customer ?"
  );
  const [chitData, setChitData] = useState({
    customer_id: "",
    active_plan_id: "",
    payment_status: "",
    date_filter: "",
    custom_start: "",
    custom_end: "",
  })
  const [customerList, setCustomerList] = useState([])
  const [activePlanList, setActivePlan] = useState([])
  const [error, setError] = useState(null)
  const navigate = useNavigate();


  const fetch = async (page = 1) => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      let endpoint = `public/api/chit/details?$page=${page}`;

      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const customerList = await axios.get(`public/api/customers/filter/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const activeplan = await axios.get(`public/api/plans/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      setActivePlan(activeplan.data)

      if (customerList.data.success) {
        setCustomerList(customerList.data.data)
      }
      if (response.data) {
        setFormData(response.data.chit_details.data)
        setPaginationData(response.data.chit_details)
        setCurrentPage(response.data.chit_details.current_page)
      }


    } catch (error) {
      console.error(error)
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      }
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetch()
  }, [])

  const handleClose = () => {
    setChitDetailsEditOpen(false);
    setCustomerEditOpen(false)
    setChitDetailsCreateOpen(false)
    setChitDetailsAddPayment(false)
    fetch()
  }

  const handleClickForView = (data) => {
    setChitDetailsEditOpen(true);
    setCustomerId(data)

  };

  const handleClickAddPayment = (data) => {
    setChitDetailsAddPayment(true)
    setCustomerId(data)
  }

  const handlePageChange = (page) => {
    if (page !== "...") {
      handleFilter(page);
    }
  };

  const handleClick = () => {
    setChitDetailsCreateOpen(true)
  }

  const handleFilter = async (page = 1) => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      let endpoint = `public/api/chit/details`;


      const response = await axios.get(endpoint, {
        params: {
          page: page,
          customer_id: chitData.customer_id,
          active_plan_id: chitData.active_plan_id,
          payment_status: chitData.payment_status,
          date_filter: chitData.date_filter,
          custom_start: chitData.custom_start,
          custom_end: chitData.custom_end,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (response.data) {
        setFormData(response.data.chit_details.data)
        setPaginationData(response.data.chit_details)
      }
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      }
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setChitData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }


  const resetFilter = () => {
    setChitData({
      customer_id: "",
      active_plan_id: "",
      payment_status: "",
      date_filter: "",
      custom_start: "",
      custom_end: "",
    })
    fetch();

  }


  const handleClickForWhatsApp = (data) => {
  

    const customerName = data?.customer?.name || "Customer";
    const payableAmount = data?.payable_amount - data?.amount_received || "0.00";
    const paidAmount = data?.amount_received
    // if (data?.amount_received === 0) {
    //   const message = `Hello ${customerName},\n🔔 Payment Reminder\nYour SS Chit payable amount is ₹${payableAmount}.\nKindly make the payment at the earliest to avoid inconvenience.\n— SS Chits `
    // }

    // if (data?.payable_amount === data?.amount_received) {
    //   const message = `Hello ${customerName},\n ✓ Payment Successful!\nWe have received your SS Chit payment of ₹${payableAmount}.
    //      \nThank you for paying on time.`;
    // }

    let message = ""
    if (data?.payment_status === "Paid") {
      message = `Hello ${customerName},\n\n ✓ Payment Successful!\n\nWe have received your SS Chit payment of ₹${paidAmount}.\nThank you for paying on time.\n\n— SS Chits (Ram Chit Finance)`;
    }
    if (data?.payment_status === "unpaid") {
      message = `Hello ${customerName},\n\n  Partial Payment Received\n\nYou have paid ₹${paidAmount}.\nRemaining balance to be paid: ₹${data?.pending_amount}.\n\nPlease complete the payment at the earliest.\n\n— SS Chits (Ram Chit Finance)`;
    }
    if (data?.payment_status === "Partially Paid") {
      message = `Hello ${customerName},\n\n🔔 Payment Reminder\n\nYour SS Chit payable amount is ₹${data?.pending_amount}.\nKindly make the payment at the earliest to avoid inconvenience.\n\n— SS Chits (Ram Chit Finance)`;
    }


    // const message = `Hello ${customerName},\nYour Ram Chits payable amount is ₹${payableAmount}.`;
    const url = `https://wa.me/${data.customer.phone}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };


  if (loading) {
    return (
      <Loader />
    )
  }
  return (
    <div>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className=" font-semibold text-3xl text-gray-900">Chit Details</h1>
            <p className="mt-2 text-sm text-gray-700">
              Chit Details all your chit fund Customer and their details..
            </p>
          </div>
          {/* <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              onClick={handleClick}
              className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Add chit Details
            </button>
          </div> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          {/* Select Plan */}
          <div>
            <select
              id="customer_id"
              name="customer_id"
              value={chitData.customer_id}
              onChange={handleChange}
              autoComplete="plan_id"
              className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
            >
              <option value="">Select Customer</option>
              {customerList?.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <select
              id="active_plan_id"
              name="active_plan_id"
              value={chitData.active_plan_id}
              onChange={handleChange}
              autoComplete="plan_id"
              className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
            >
              <option value="">Select Active Plan</option>
              {activePlanList?.map((type) => (
                <option key={type.id} value={type.name}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <select
              id="payment_status"
              name="payment_status"
              value={chitData.payment_status}
              onChange={handleChange}
              autoComplete="plan_id"
              className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
            >
              <option value="">Select Payment Status</option>
              <option value="unpaid">UnPaid</option>
              <option value="Partially Paid">Partially Paid</option>
              <option value="Paid">Paid</option>

            </select>
          </div>


          <div>
            <select
              id="date_filter"
              name="date_filter"
              value={chitData.date_filter}
              onChange={handleChange}
              autoComplete="plan_id"
              className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
            >
              <option value="">Select Date Filter </option>
              <option value="today"> Today</option>
              <option value="yesterday"> Yesterday</option>
              <option value="tomorrow"> Tomorrow</option>
              <option value="this_week"> This week</option>
              <option value="this_month"> This Month</option>
              <option value="this_quarter"> This Quarter</option>
              <option value="this_year"> This year</option>
              <option value="last_year"> Last year</option>
              <option value="this_financial_year">This Financial Year </option>
              <option value="last_financial_year"> last Financial Year </option>
              <option value="custom"> Custom </option>
            </select>
          </div>


          {chitData.date_filter === "custom" && (
            <>
              <div>
                <input
                  id="custom_start"
                  name="custom_start"
                  type="date"
                  className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
                  onChange={handleChange}
                  value={chitData.custom_start}
                />
              </div>
              <div>
                <input
                  id="custom_end"
                  name="custom_end"
                  type="date"
                  className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
                  onChange={handleChange}
                  value={chitData.custom_end}
                />
              </div>
            </>
          )}


          {/* Filter Button */}
          <div className="flex items-center">
            <button
              className="w-full rounded-md bg-[#0f172a] px-3 py-2 text-sm font-semibold text-white 
                 shadow-sm hover:bg-teal-900 focus-visible:outline-2 
                 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"

              onClick={() => handleFilter(1)}
            >
              Filter
            </button>
          </div>

          {/* Clear Button (optional, for balance) */}
          <div className="flex items-center">
            <button
              className="w-full rounded-md bg-gray-200 px-3 py-2 text-sm font-semibold text-gray-700 
                 shadow-sm hover:bg-gray-300 focus-visible:outline-2 
                 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={() => resetFilter()}
            >
              Clear
            </button>
          </div>
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 border rounded-md align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden shadow-sm sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300 shadow-xl">
                  {/* <thead className=" text-[#649ece] hover:bg-gray-100"> */}
                  <thead className="text-white  bg-[#0f172a]">
                    <tr>
                      <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                        #
                      </th>
                      <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                        Customer Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Active Plan
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Payout Status
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Month
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Entry Date
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Payable Amount
                      </th>

                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Payment Status
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Amount Received
                      </th>
                      {/* <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                        Total Amount
                      </th> */}

                      <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-6">
                        Action
                      </th>
                    </tr>
                  </thead>

                 
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {formData.map((person, index) => (
                      <tr key={index}
                        className={`hover:bg-gray-100`}
                      >
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">

                          {paginationData.from + index}
                        </td>
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                          {/* {person.name} */}
                          {person?.customer?.name || "N/A"}
                        </td>
                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                          {person.active_plan?.plan.name + "-" + person.active_plan?.group.group_name || "N/A"}

                        </td>
                        <td className={`px-3 py-4 text-sm whitespace-nowrap ${person.customer_payout_status == 1 ? "text-green-600" : "text-gray-600"}`}>{person.customer_payout_status == 1 ? "paid" : "unpaid"}</td>
                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{person.month || "N/A"}</td>
                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{new Date(person.entry_date).toLocaleDateString("en-GB") || "N/A"}</td>
                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{person.payable_amount || "0"}</td>

                        <td className="px-3 py-4 text-sm whitespace-nowrap">
                          <span
                            className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                                ${person.payment_status == "unpaid" ? "bg-red-200 text-red-800" : ""}
                                ${person.payment_status == "Paid" ? "bg-green-200 text-green-600" : ""}
                                ${person.payment_status == "Partially Paid" ? "bg-yellow-200 text-yellow-600" : ""}
                              `}
                          >
                            {person.payment_status}
                          </span>
                        </td>

                        <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{person.amount_received}</td>


                        <td className="px-3 py-4 p-2  text-center text-sm font-medium whitespace-nowrap sm:pr-6 gap-2">
                          <div className='flex gap-2'>


                            <button
                              type="button"
                              className=" rounded bg-white px-5 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                              onClick={() =>
                                handleClickAddPayment(person)
                              }
                            >
                              Add payment
                            </button>


                            <button
                              onClick={() => handleClickForWhatsApp(person)}
                              className="p-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition"
                              title="Send WhatsApp Message"
                            >
                              <FaWhatsapp size={20} />
                            </button>
                          </div>

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {paginationData && (
        <Pagination
          links={paginationData?.links}
          currentPage={paginationData?.current_page}
          totalResults={paginationData?.total}
          from={paginationData?.from}
          to={paginationData?.to}
          lastPage={paginationData?.last_page}
          onPageChange={handlePageChange}
        />
      )}

      <Transition.Root show={chitDetailCreateOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => { }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <ChitDetailsCreate
                      close={handleClose}
                    // closeModal={closeModal}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={chitDetailsEditOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setChitDetailsEditOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <ChitDetailsEdit
                      close={handleClose}
                      chitData={customerId}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={chitDetailsAddPayment} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setChitDetailsAddPayment}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <ChitDetailsAddPayment
                      close={handleClose}
                      chitData={customerId}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

    </div>
  )
}

export default ChitDetailsList
